export default __webpack_public_path__ + "static/media/image-work-personal-m.3190e4c7.webp";